import styled from '@emotion/styled';
import { getColor } from '../../common/UICommon';
import { TabletWidth } from '../../../global.style';

export const PickAProductContentV3ContentDesktopRightEggBg = styled.img`
  position: absolute;
  z-index: 0;
  right: 0px;
  top: -340px;

  @media (max-width: ${TabletWidth}px) {
    display: none;
  }
`;

export const PickAProductContentV3ContentDesktopLeftEggBg = styled.img`
  position: absolute;
  z-index: 0;
  left: 0px;
  top: 1300px;

  @media (max-width: ${TabletWidth}px) {
    display: none;
  }
`;

export const PickAProductContentV3ContentDesktopLeftBeigeEggBg = styled.img`
  position: absolute;
  z-index: 0;
  left: 0px;
  bottom: 0px;

  @media (max-width: ${TabletWidth}px) {
    display: none;
  }
`;

export const PickAProductContentV3ContentWrapper = styled.div`
  padding-top: 140px;
  padding-bottom: 210px;
  overflow: hidden;

  @media (max-width: ${TabletWidth}px) {
    padding-top: 75px;
    padding-bottom: 180px;
  }
`;

export const PickAProductContentV3Info = styled.div`
  font-size: 12px;
  line-height: 18px;
  font-weight: 400;
  color: ${getColor('GRAY_60')};
  margin-top: 24px;
  text-align: center;
  white-space: pre-line;

  @media (max-width: ${TabletWidth}px) {
    margin-top: 16px;
  }
`;

export const PickAProductContentV3StickyInfo = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  color: ${getColor('GRAY_60')};
  white-space: pre-line;
`;

export const PickAProductContentV3DesktopCtaSection = styled.div`
  max-width: 1120px;
  margin: auto;
  padding-bottom: 48px;

  @media (max-width: ${TabletWidth}px) {
    display: none;
  }
`;

export const PickAProductContentV3DesktopWrapper = styled.div`
  max-width: 330px;
  width: 100%;
  z-index: 1;
  margin: auto;
`;

export const PickAProductContentV3StickyHeader = styled.div<{ isVisible: boolean }>`
  width: 100%;
  position: fixed;
  top: 0;
  background-color: ${getColor('BEIGE_5')};
  z-index: 99;
  border-bottom: 1px solid ${getColor('GRAY_40')};
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  transform: ${({ isVisible }) => (isVisible ? 'translateY(0)' : 'translateY(-100%)')};
  transition: opacity 0.3s ease, transform 0.3s ease;
  transition: visibility 0s linear 0.3s, opacity 0.3s ease, transform 0.3s ease;

  @media (max-width: ${TabletWidth}px) {
    display: none;
  }
`;

export const PickAProductContentV3StickyHeaderContent = styled.div`
  max-width: 1440px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 22px 20px 22px 32px;
`;

export const PickAProductContentV3StickyHeaderButtonWrapper = styled.div`
  max-width: 250px;
  width: 100%;
`;

export const PickAProductContentV3MobileCtaSection = styled.div`
  display: none;

  @media (max-width: ${TabletWidth}px) {
    background-color: ${getColor('DARK_CREAM')};
    border-top: 1px solid ${getColor('GRAY_20')};
    display: block;
    position: fixed;
    bottom: 0px;
    width: 100%;
    z-index: 2;
    padding: 16px 24px;
  }
`;

export const PickAProductContentV3MobileCtaSectionContent = styled.div`
  max-width: 330px;
  margin: auto;
`;

export const PickAProductContentV3SectionAwards = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  gap: 28px;
  width: 100%;
  max-width: 330px;
  margin: auto;
  margin-bottom: 47px;

  @media (max-width: ${TabletWidth}px) {
    margin-bottom: 0px;
  }
`;

export const PickAProductContentV3SectionAwardImg = styled.img`
  width: 100%;
  height: auto;
  object-fit: contain;
`;

export const PickAProductContentV3LabelWrapper = styled.div`
  margin-bottom: 36px;
  text-align: center;

  @media (max-width: ${TabletWidth}px) {
    margin-bottom: 60px;
    padding: 0px 24px;
  }
`;

export const PickAProductContentV3Label = styled.span<{ bold?: boolean }>`
  font-size: 16px;
  font-weight: ${({ bold }) => (bold ? '500' : '400')};
  line-height: 25px;
  display: block;

  @media (max-width: ${TabletWidth}px) {
    font-size: 14px;
    line-height: 23px;
    display: inline;
  }
`;

export const PickAProductContentV3TrustedTitle = styled.p`
  font-family: Lora;
  font-size: 28px;
  font-weight: 600;
  line-height: 42px;
  text-align: center;
  margin-bottom: 18px;

  @media (max-width: ${TabletWidth}px) {
    font-size: 24px;
    line-height: 36px;
  }
`;
